import BaseApi from "./BaseApi";

class SampleContentApi extends BaseApi {
  async getSampleContent(contentType, language) {
    return await this.API({
      url: `/sample-content/get-content?contentType=${encodeURIComponent(contentType)}&language=${encodeURIComponent(language)}`,
      method: "get"
    });
  }

  async updateSampleContent(data) {
    return await this.API({
      url: "/sample-content/update-content",
      data: data,
      method: "post"
    });
  }
}

export default SampleContentApi;
